const vehicleStats = (stations: any) => {
  let data: any = [];
  let obj: any = {};
  stations.forEach((station: any) => {
    obj = { name: station.name, vehicles: station.checkpoints.length };
    data.push(obj);
  });

  return data;
};

export default vehicleStats;
